// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * What an Azure DevOps connection is actually allowed to do, detected by probing the live Azure DevOps APIs. Each capability is `connected` (the connection can access it), `no_access` (the granted permissions do not cover it), or `unknown` (access could not be determined, e.g. the probe failed or the profile has no project selected yet).
 * @export
 * @interface IssueManagerProfileCapabilities
 */
export interface IssueManagerProfileCapabilities {
  /**
   * Whether the connection can read work items.
   * @type {string}
   * @memberof IssueManagerProfileCapabilities
   */
  workItems?: IssueManagerProfileCapabilitiesWorkItemsEnum;
  /**
   * Whether the connection can read deployments (Azure DevOps releases).
   * @type {string}
   * @memberof IssueManagerProfileCapabilities
   */
  deployments?: IssueManagerProfileCapabilitiesDeploymentsEnum;
  /**
   * Whether the connection can read pipelines (Azure DevOps builds).
   * @type {string}
   * @memberof IssueManagerProfileCapabilities
   */
  pipelines?: IssueManagerProfileCapabilitiesPipelinesEnum;
  /**
   * Whether the connection can manage service hooks, which are needed to set up automatic deployment/build notifications.
   * @type {string}
   * @memberof IssueManagerProfileCapabilities
   */
  serviceHooks?: IssueManagerProfileCapabilitiesServiceHooksEnum;
  /**
   * When the capabilities were last detected (ISO 8601 timestamp).
   * @type {string}
   * @memberof IssueManagerProfileCapabilities
   */
  checkedAt?: string;
}

export function IssueManagerProfileCapabilitiesFromJSON(
  json: any
): IssueManagerProfileCapabilities {
  return {
    workItems: !exists(json, "work_items") ? undefined : json["work_items"],
    deployments: !exists(json, "deployments") ? undefined : json["deployments"],
    pipelines: !exists(json, "pipelines") ? undefined : json["pipelines"],
    serviceHooks: !exists(json, "service_hooks")
      ? undefined
      : json["service_hooks"],
    checkedAt: !exists(json, "checked_at") ? undefined : json["checked_at"],
  };
}

export function IssueManagerProfileCapabilitiesToJSON(
  value?: IssueManagerProfileCapabilities
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    work_items: value.workItems,
    deployments: value.deployments,
    pipelines: value.pipelines,
    service_hooks: value.serviceHooks,
    checked_at: value.checkedAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum IssueManagerProfileCapabilitiesWorkItemsEnum {
  Connected = "connected",
  NoAccess = "no_access",
  Unknown = "unknown",
}
/**
 * @export
 * @enum {string}
 */
export enum IssueManagerProfileCapabilitiesDeploymentsEnum {
  Connected = "connected",
  NoAccess = "no_access",
  Unknown = "unknown",
}
/**
 * @export
 * @enum {string}
 */
export enum IssueManagerProfileCapabilitiesPipelinesEnum {
  Connected = "connected",
  NoAccess = "no_access",
  Unknown = "unknown",
}
/**
 * @export
 * @enum {string}
 */
export enum IssueManagerProfileCapabilitiesServiceHooksEnum {
  Connected = "connected",
  NoAccess = "no_access",
  Unknown = "unknown",
}
